import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TimecardStoreProps } from 'types/timecards';
import { UserData } from 'types/user';

const initialState: TimecardStoreProps = {
    trackedTimecardId: undefined,
    isStopwatchRunning: false,
    draftTimecardsLoading: false,
    timecardDuration: undefined,
};

const timecard = createSlice({
    name: 'timecard',
    initialState,
    reducers: {
        trackTimecard(
            state,
            action: PayloadAction<{
                timecardId: number;
                userId: number | null;
                tenantId: string | null;
                isStopwatchRunning: boolean;
            }>
        ) {
            const { timecardId, isStopwatchRunning } = action.payload;
            state.trackedTimecardId = String(timecardId);
            state.isStopwatchRunning = isStopwatchRunning;
        },
        setTimecardDuration(state, action: PayloadAction<string>) {
            state.timecardDuration = action.payload;
        },
        setStopwatchRunning(state, action: PayloadAction<boolean>) {
            state.isStopwatchRunning = action.payload;
        },
        setTrackedTimecardId(state, action: PayloadAction<string | undefined>) {
            state.trackedTimecardId = action.payload;
        },
        resetTimecardState(state, _action: PayloadAction<{ userId: number | null; tenantId: string | null }>) {
            state.isStopwatchRunning = false;
            state.trackedTimecardId = undefined;
            state.timecardDuration = undefined;
        },
        setDraftTimecardsLoading(state, action: PayloadAction<boolean>) {
            state.draftTimecardsLoading = action.payload;
        },
        switchTrackedTimecard(_state, _action: PayloadAction<UserData>) {
            // This action will be handled by middleware for localStorage sync
            // The middleware will dispatch setTrackedTimecardId if needed
        },
    },
});

export default timecard.reducer;

export const {
    trackTimecard,
    setStopwatchRunning,
    setTrackedTimecardId,
    resetTimecardState,
    setDraftTimecardsLoading,
    switchTrackedTimecard,
    setTimecardDuration,
} = timecard.actions;
